/**
 * Parseo y armado de teléfono internacional (E.164 en UI como "+54 11 …").
 * @param {Array<{ code: string, dialCode: string }>} phoneCountries
 */
export function parseInternationalPhone(raw, phoneCountries = []) {
  const value = String(raw || '').trim();
  if (!value) {
    return { countryCode: '', dialCode: '', national: '' };
  }

  const sorted = [...phoneCountries].sort(
    (a, b) => String(b.dialCode).length - String(a.dialCode).length,
  );

  const compact = value.replace(/\s/g, '');
  if (compact.startsWith('+')) {
    for (const row of sorted) {
      const dialDigits = String(row.dialCode || '').replace(/^\+/, '');
      if (!dialDigits) continue;
      if (compact.startsWith(`+${dialDigits}`)) {
        const rest = compact.slice(1 + dialDigits.length);
        return {
          countryCode: row.code,
          dialCode: row.dialCode,
          national: formatNationalDisplay(rest),
        };
      }
    }
  }

  return { countryCode: '', dialCode: '', national: value };
}

export function formatNationalDisplay(value) {
  return String(value || '')
    .replace(/[^\d\s()-]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function sanitizeNationalInput(value) {
  return formatNationalDisplay(value);
}

export function formatInternationalPhone(dialCode, national) {
  const n = sanitizeNationalInput(national);
  const d = String(dialCode || '').trim();
  if (!d && !n) return '';
  if (!n) return d;
  if (!d) return n;
  return `${d} ${n}`.trim();
}

export function findPhoneCountryByIso(phoneCountries, isoCode) {
  const code = String(isoCode || '').trim().toUpperCase();
  if (!code || !Array.isArray(phoneCountries)) return null;
  return phoneCountries.find((r) => r.code === code) || null;
}
